import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class PlotDeleteUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}
    async execute(farmId: number, plotId: string): Promise<boolean> {
        const result = await this.farmRepository.deletePlot(farmId, plotId);

        return result.match(
            () => {
                ToastManagerRepository.success();
                return true;
            },
            (error) => {
                ToastManagerRepository.error(error.message);
                return false;
            },
        );
    }
}
